var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#62850B",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.279 16.279A6.052 6.052 0 1 1 7.721 7.72a6.052 6.052 0 0 1 8.558 8.559m-2.582-2.796c.78-.167 1.543-.257 2.289-.283c.339-.007.675.06.985.197c.086.034.086.077.013.124a7.2 7.2 0 0 1-2.456 1.012c-.428.086-.454.231-.055.437q.587.3 1.045.724q.11.102-.042.12c-1.14.142-2.092-.218-3.06-.78c-.082-.043-.129-.025-.146.065c-.094.445-.343 1.465-.776 1.671a.05.05 0 0 1-.06-.009a.043.043 0 0 1 0-.055a3.44 3.44 0 0 0 .613-1.607a.1.1 0 0 0-.043-.095a.1.1 0 0 0-.103-.008c-1.05.531-2.014.968-3.24.827a.09.09 0 0 1-.072-.06a.09.09 0 0 1 .02-.086c.29-.267.618-.488.974-.656c.471-.222.454-.385-.06-.484a6.6 6.6 0 0 1-2.529-1.046a.07.07 0 0 1-.033-.083a.1.1 0 0 1 .016-.028a.1.1 0 0 1 .039-.021c1.045-.313 2.254-.086 3.321.132c.146.03.163 0 .047-.098a8.6 8.6 0 0 1-2.37-3.24q-.29-.709.365-.317a10.1 10.1 0 0 1 2.798 2.443q.15.193.086-.043a3.3 3.3 0 0 1-.12-1.342q.054-.337.102-.667c.142-.95.278-1.86.626-2.821a.3.3 0 0 1 .146-.172a.1.1 0 0 1 .118.017q.015.015.024.035c.287.685.505 1.388.655 2.125c.126.606.118 1.24.11 1.87c-.003.276-.006.55.002.822q.006.172.115.043a10.2 10.2 0 0 1 3.035-2.486q.322-.168.188.171a10.1 10.1 0 0 1-1.757 2.876a2.9 2.9 0 0 1-.801.673a.1.1 0 0 0-.043.064a.04.04 0 0 0 0 .022q.013.024.034.017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.991 16.991A7.058 7.058 0 1 1 7.01 7.01a7.058 7.058 0 0 1 9.982 9.981m-.388-.388a6.51 6.51 0 1 1-9.206-9.206a6.51 6.51 0 0 1 9.206 9.206"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.fba0cde7bb3c897a3797d82bbb932238.svg";
export { ForwardRef as ReactComponent };